const getObjectWithLatestTimestamp = (obj) => {
  return obj.reduce((prev, current) => {
    return prev.timestamp_ms > current.timestamp_ms ? prev : current;
  });
};

export default getObjectWithLatestTimestamp;
